var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryPiggyBank = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.747 5.708c-5.211 0-9.425 4.246-9.425 9.425 0 5.21 4.246 9.425 9.425 9.425s9.425-4.246 9.425-9.425c0-5.211-4.246-9.425-9.425-9.425z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.99 22.467-3.925-.676c-.482-.772-1.093-1.48-1.737-2.123a8.332 8.332 0 0 1 2.927-4.825l.226-.193c.386-.29.514-.804.353-1.254a1.141 1.141 0 0 0-1.061-.772h-3.024a7.202 7.202 0 0 0-6.337 3.828c-.418-.033-.804-.065-1.19-.065h-2.863c-.643 5.855-5.597 10.422-11.612 10.422a11.682 11.682 0 0 1-8.396-3.538c-.675 1.512-1.061 3.152-1.061 4.825 0 3.603 1.672 7.013 4.535 9.232v5.855a1.14 1.14 0 0 0 1.126 1.126h4.536c.482 0 .932-.322 1.061-.772l1.255-3.764h10.583l1.254 3.764c.161.45.58.772 1.062.772h4.535a1.14 1.14 0 0 0 1.126-1.126v-5.855a11.963 11.963 0 0 0 3.57-4.6l3.282-1.319c.418-.16.708-.579.708-1.061V23.56c.032-.547-.386-.998-.933-1.094zm-8.846 2.605a1.14 1.14 0 0 1-1.126-1.125 1.14 1.14 0 0 1 1.126-1.126 1.14 1.14 0 0 1 1.126 1.126 1.14 1.14 0 0 1-1.126 1.125z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryPiggyBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-piggy-bank.20bc2075cfe350e559afb13c19ead6bc.svg";